import React from "react";
import { Box, HStack, Heading, Icon } from "@chakra-ui/react";
import { DisplayQuestionContent } from "../../../../../components/DisplayQuestionContent";
import { ListeningQuestionData } from "../../../../../types/listening-types";
import { InfoIcon } from "@chakra-ui/icons";
import {
  listeningDefaultInstruction,
} from "../../../../../utils/helperFuntions";
import { VideoPlayer } from "../../../../../components/AudioAndVideoPlayer";

type ListeningToADiscussionProps = {
  questionData: ListeningQuestionData;
  stage: number;
};

export const InstructionHeading: React.FC<{ text: string }> = ({ text }) => (
  <HStack>
    <Icon as={InfoIcon} color="blue.500" />
    <Heading size="sm" color="blue.600">
      {text}
    </Heading>
  </HStack>
);


export const ListeningToADiscussion: React.FC<ListeningToADiscussionProps> = ({
  questionData,
  stage,
}) => {
  const renderContent = () => {
    switch (stage) {
      case 0:
        return <DisplayQuestionContent content={questionData.listeningInstructionOne} />;
      case 1:
        return (
          <Box mt={9}>
            <DisplayQuestionContent content={questionData.listeningInstructionTwo} />
          </Box>
        );
      case 2:
        return (
          <>
            <InstructionHeading text={listeningDefaultInstruction} />
            <VideoPlayer src={questionData.listeningToProblemSolvingAudioOne} />
          </>
        );
      default:
        return null;
    }
  };

  return <Box>{renderContent()}</Box>;
};
